const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const USERNAME_REGEX = /^[\u4e00-\u9fa5a-zA-Z0-9_]{2,32}$/;
const PASSWORD_MIN = 8;
const PASSWORD_MAX = 64;

export function validateEmail(email: string): string | null {
  const v = email.trim().slice(0, 255);
  if (!v) return '邮箱为必填项';
  if (!EMAIL_REGEX.test(v)) return '邮箱格式不正确';
  return null;
}

export function validateUsername(username: string): string | null {
  const v = username.trim().slice(0, 32);
  if (!v) return '用户名为必填项';
  if (!USERNAME_REGEX.test(v)) return '用户名需 2-32 位，仅支持中文、字母、数字、下划线';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return '密码为必填项';
  if (password.length < PASSWORD_MIN || password.length > PASSWORD_MAX) {
    return `密码长度需 ${PASSWORD_MIN}-${PASSWORD_MAX} 位`;
  }
  if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
    return '密码需同时包含字母和数字';
  }
  return null;
}

export function validateLoginForm(email: string, password: string): string | null {
  const emailErr = validateEmail(email);
  if (emailErr) return emailErr;
  if (!password) return '密码为必填项';
  if (password.length > PASSWORD_MAX) return `密码不能超过 ${PASSWORD_MAX} 位`;
  return null;
}

export function validateRegisterForm(
  username: string,
  email: string,
  password: string,
  confirmPassword: string
): string | null {
  const usernameErr = validateUsername(username);
  if (usernameErr) return usernameErr;
  const emailErr = validateEmail(email);
  if (emailErr) return emailErr;
  const pwdErr = validatePassword(password);
  if (pwdErr) return pwdErr;
  if (password !== confirmPassword) return '两次输入的密码不一致';
  return null;
}
